import type { DocumentUploads } from '@/features/section-2/application/domain/entities/DocumentUploads';
import { II9FormViewerRepository } from '../ports/II9FormViewerRepository';

/** The labeled uploads of a Section 2's other documents, for the record's document pages (VTK-2039). */
export class FetchDocumentFilesUseCase {
  constructor(private readonly repository: II9FormViewerRepository) {}

  async execute(i9FormId: string): Promise<DocumentUploads> {
    return this.repository.fetchDocumentFiles(i9FormId);
  }

  /** The labeled uploads kept with each completed Supplement B on the I-9 (VTK-2152). */
  async executeSupplementB(i9FormId: string): Promise<DocumentUploads> {
    return this.repository.fetchSupplementBDocumentFiles(i9FormId);
  }
}
